import * as Joi from "joi";
import i18n from "i18n/index";

export const PROMO_SCHEMA = Joi.object({
    code: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Promo code"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    expireDate: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Expire date"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    discount: Joi.number()
        .required()
        .label(i18n.t("Discount"))
        .messages({ 
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'number.base': `{#label} ${i18n.t("validationErrors.isRequired")}`,
         }),
})